import { GridColDef } from '@mui/x-data-grid';
import { renderSensorName } from './RenderSensorName';

export const timeseriesColumns: GridColDef[] = [
  { field: 'name', renderCell: renderSensorName, headerName: 'Sensor Name', flex: 1 },
];
